import emojiRegex from "emoji-regex";

// todo: refactor inbox to use this version
export function isJustEmoji(string) {
    // Has Emoji: Ensure all whitespace is not counted as emoji
    const hasEmojiRegex = new RegExp(`${emojiRegex().source}`);
    // Just Emoji: (start-of-string)(1 or more emoji, spaces, or newlines)(end-of-string)
    const justEmojiRegex = new RegExp(`^((${emojiRegex().source})|[ \n])+$`);
    return hasEmojiRegex.test(string) && justEmojiRegex.test(string);
}

export function hasUnicode(string) {
    // Unicode character: Any character that is not in hex 00 to 7F (basic ASCII)
    // eslint-disable-next-line no-control-regex
    const unicodeCharacterRegex = /[^\u0000-\u007F]/;
    return unicodeCharacterRegex.test(string);
}

/**
 * @param options An array of plain (unescaped) strings
 * @param capture Whether to use a capture group `/()/` or not `/(?:)/`
 * @returns A regex which will match any of the options anywhere in a string
 */
export function convertToRegexGroup(options, capture = false) {
    const escapedOptions = longestMatchSort(options).map(option => basicEscapeRegExp(option));
    return `(${capture ? '' : '?:'}${escapedOptions.join('|')})`;

}

/** Basic escape functionality for use in convertToRegexGroup and similar */
// todo: Upgrade shims to support Regexp.escape (e.g., Babel 8)
function basicEscapeRegExp(string) {
    return string.replace(/[$^\\.*+?()[\]{}|/]/g, '\\$&'); // $& means the whole matched string
}

function escapeHtml(unsafe) {
    return unsafe
        // Replace & first to avoid double-escaping already escaped characters
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
}

/** Sort items in descending order to emulate POSIX longest match behavior.
 * For example, PARTICIPANT_LASTNAME is sorted before PARTICIPANT_LAST */
function longestMatchSort(items) {
    return items.sort().reverse();
}

/**
 * @param string the haystack
 * @param variables an array of needles in any order
 * @returns {{length: number, variables: number}} the length of the string without variables, and the number of variables found
 */
export function getVariableAdjustedLength(string, variables) {
    let count = 0;
    const result = longestMatchSort(variables).reduce((acc, variable) => {
        // todo: replace `replace` with replaceAll when available
        return acc.replace(new RegExp(basicEscapeRegExp(variable), 'g'), () => {
            count++;
            return '';
        });
    }, string);
    return {length: result.length, variables: count }
}

/**
 * @param string the haystack
 * @param variables an array of needles in any order
 * @returns The string with spans added around each variable to use in v-html
 */
export function styleVariables(string, variables) {
    const regexGroup = convertToRegexGroup(variables);
    return escapeHtml(string).replace(new RegExp(regexGroup, 'g'), (variable) => {
        const safe = escapeHtml(variable);
        return `<span>${safe}</span>`;
    });
}

/**
 * @param count the number of items
 * @param singular the singular form of the item
 * @param plural the plural form of the item (optional, defaults to singular + 's')
 * @returns formatted string: '1 item' or '# items'
 */
export function pluralize(count, singular, plural) {
    return `${count} ` + (count === 1 ? singular : (plural ?? singular + 's'));
}